import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import api from "../app/api";
import Alert, { DeleteAlert, UpdateAlert } from '../components/Swal Alert/index';
import useAlert from "./useAlert";

import { addFellowAdmin, deleteFellowAdmin, setFellowAdmin, updateFellowAdmin } from "../features/fellowAdmin/slice";

export default () => {
  const dispatch = useDispatch();
  const { fellowAdmins } = useSelector(state => state.fellowAdmins)

  const { showAlert } = useAlert()

  // STATES
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  // New Admin State
  const [data, setData] = useState({
    name: '',
  })
  const fetchAdmins = async (params) => {
    setLoading(true);
    try {
      const response = await api.get(`/fellowAdmin`, { params });
      dispatch(setFellowAdmin(response.data))
      setLoading(false);
    } catch (err) {
      const message = err.response ? err.response.data?.message ? err.response.data?.message : err.response.data : err;
      //(message)
      showAlert(message, 'danger');
      setLoading(false);
    }
  }
  const fetchFellowAdminByAdminId = async (params) => {
    setLoading(true);
    try {
      const response = await api.get(`/fellowAdmin/getAdminFellowAdmin`, { params });
      dispatch(setFellowAdmin(response.data))
      setLoading(false);
    } catch (err) {
      const message = err.response ? err.response.data?.message ? err.response.data?.message : err.response.data : err;
      //(message)
      showAlert(message, 'danger');
      setLoading(false);
    }
  }
  const newAdmin = async () => {
    setAddLoading(true);
    try {
      const response = await api.post('/fellowAdmin/new', {...data});
      dispatch(addFellowAdmin(response.data.data))
      setAddLoading(false);
      setData({ name: '', email: '', status: false, adminID:'' })
      showAlert(response.data.message, 'success');
    } catch (err) {
      const message = err.response ? err.response.data?.message ? err.response.data?.message : err.response.data : err;
      //(message)
      Alert('error', message);
      // showAlert(message, 'danger');
      setAddLoading(false);
    }
  }
  const changeAdmin = async () => {
    if (!await UpdateAlert()) return
    setAddLoading(true);
    try {
      const response = await api.put(`/fellowAdmin/update/${data._id}`,  {...data});
      dispatch(updateFellowAdmin(data))
      setData({ name: '', email: '', status: false, adminID:'' })
      setAddLoading(false);
      showAlert('Admin updated successfully', 'success');
    } catch (err) {
      const message = err.response ? err.response.data?.message ? err.response.data?.message : err.response.data : err;
      //(message)
      showAlert(message, 'danger');
      setAddLoading(false);
    }
  }
  const removeAdmin = async (item) => {
    if (!await DeleteAlert()) return
    setDeleteLoading(item);
    try {
      const response = await api.delete(`/fellowAdmin/delete/${item ? item._id : data._id}`);
      dispatch(deleteFellowAdmin(item))
      setDeleteLoading(false);
      showAlert('Admin removed successfully', 'success');
    } catch (err) {
      const message = err.response ? err.response.data?.message ? err.response.data?.message : err.response.data : err;
      //(message)
      showAlert(message, 'danger');
      setDeleteLoading(false);
    }
  }

  return {
    fellowAdmins,
    loading,
    addLoading,
    deleteLoading,
    data,
    setData,
    fetchAdmins,
    newAdmin,
    changeAdmin,
    removeAdmin,
    fetchFellowAdminByAdminId
  }
}